import { createContext, useContext } from "react";

export const ModalContext = createContext();
export const NFTContext = createContext();


export const useModal = () => useContext(ModalContext);
export const useNFTContext = () => useContext(NFTContext);